import React, { useState } from 'react';
import {
    ListRow,
    RowIcon,
    RowInfoStack,
    RowH1,
    // TeamCard,
    // TextWrapper,
    // TopLine,
    // FormH4,
    SelectButton,
    Img,
    PlayerName,
    PlayerCost,
    RemoveButton,
    ListRowSlot,
    ColInfoStack,
    // DetailsWrap,
    // StatsWrap,
    // ImgWrap,
    // Img
} from './ClassicTeamTableElements';
import teamLogos from '../LogoImageForms/TeamLogos';
import List from '@mui/material/List';

const ClassicTableRow = ({ player, position, index, handleRemove, handleFill, setFocusAsset = null }) => {

    const [hoverAction, setHoverAction] = useState(null);


    const logo = teamLogos[player?.team];

    return (
        <>
            {player ? (
                <ListRow
                    key={player}
                >
                    <RowIcon>
                        <Img src={logo} alt={player.position} />
                    </RowIcon>

                    <ColInfoStack>
                        <PlayerName>{player.name}</PlayerName>
                        <RowInfoStack>
                            <PlayerCost>Cost: ${player.currentCost}</PlayerCost>
                            <PlayerCost>Projection: {player.dkPoints}</PlayerCost>
                        </RowInfoStack>
                    </ColInfoStack>
                    <RemoveButton onClick={handleRemove(player)}>
                        Remove
                    </RemoveButton>
                </ListRow>
            ) :
                <ListRowSlot
                    onMouseEnter={() => setHoverAction(index)}
                    onMouseLeave={() => setHoverAction(null)}
                >
                    <ColInfoStack>
                        <RowH1 >{position}</RowH1>
                        <RowH1 style={{ color: "white", fontSize: "10px" }}></RowH1>
                    </ColInfoStack>

                    <SelectButton style={{ marginTop: '10px' }} onClick={(e) => handleFill(e, position)}>Fill</SelectButton>

                </ListRowSlot>

            }
        </>
    );
};

export default ClassicTableRow;
